"use client";
import{jsx as r}from"react/jsx-runtime";import{createContext as e,useState as o}from"react";const t=e({collapseAd:function(){}}),l=({children:e})=>{const[l,c]=o(!1);return l?null:r(t.Provider,{value:{collapseAd:()=>c(!0)},children:e})};export{t as AdCollapseContext,l as default};
